import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87ca313c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-recommend-form__field" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "現年収")
], -1))
const _hoisted_3 = { class: "p-recommend-form__error-wrap" }
const _hoisted_4 = { class: "p-recommend-form__group-1 --type-2" }
const _hoisted_5 = { class: "p-recommend-form__group-1-field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode(" 年収 "),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1))
const _hoisted_7 = { class: "p-recommend-form__group-1-field-set-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_9 = { class: "p-recommend-form__group-1 --mt-sp-1" }
const _hoisted_10 = { class: "p-recommend-form__group-1-field-set-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "月収", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_13 = { class: "p-recommend-form__group-1-field-set-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "年間賞与", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_16 = { class: "p-recommend-form__group-1 --mt-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "諸手当", -1))
const _hoisted_18 = { class: "p-recommend-form__group-1-field-set-1 align-items-baseline" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "諸手当1", -1))
const _hoisted_20 = { class: "p-recommend-form__input-group-1" }
const _hoisted_21 = { class: "p-recommend-form__input-group-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_23 = { class: "p-recommend-form__group-1-field-set-1 align-items-baseline" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "諸手当2", -1))
const _hoisted_25 = { class: "p-recommend-form__input-group-1" }
const _hoisted_26 = { class: "p-recommend-form__input-group-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_28 = { class: "p-recommend-form__group-1-field-set-1 align-items-baseline" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "諸手当3", -1))
const _hoisted_30 = { class: "p-recommend-form__input-group-1" }
const _hoisted_31 = { class: "p-recommend-form__input-group-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))
const _hoisted_33 = { class: "p-recommend-form__group-1-field-set-1 align-items-baseline" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "諸手当4", -1))
const _hoisted_35 = { class: "p-recommend-form__input-group-1" }
const _hoisted_36 = { class: "p-recommend-form__input-group-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "万円", -1))

import ValidatableField from '@/components/ValidatableField.vue';
import ResumeSelect from '../components/ResumeSelect.vue';
import InvalidMessage from '@/components/InvalidMessage.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AnnualIncomeInfoForm',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(InvalidMessage, { name: "currentAnnualIncomeNum" }),
      _createVNode(InvalidMessage, { name: "monthlyAnnualIncomeNum" }),
      _createVNode(InvalidMessage, { name: "yearBonus" }),
      _createVNode(InvalidMessage, { name: "allowanceNum1" }),
      _createVNode(InvalidMessage, { name: "allowanceNum2" }),
      _createVNode(InvalidMessage, { name: "allowanceNum3" }),
      _createVNode(InvalidMessage, { name: "allowanceNum4" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(ValidatableField, {
            class: "p-recommend-form__modal-input-2",
            id: "form-salary-1",
            type: "text",
            name: "currentAnnualIncomeNum",
            placeholder: "0",
            label: "現年収",
            rules: "required|minValue:1|max:4",
            maxlength: "4"
          }),
          _hoisted_8
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(ValidatableField, {
          class: "p-recommend-form__modal-input-2",
          id: "form-salary-2",
          type: "text",
          name: "monthlyAnnualIncomeNum",
          placeholder: "0",
          label: "月収",
          rules: "numeric|max:3",
          maxlength: "3"
        }),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(ValidatableField, {
          class: "p-recommend-form__modal-input-2",
          id: "form-salary-3",
          type: "text",
          name: "yearBonus",
          placeholder: "0",
          label: "年間賞与",
          rules: "numeric|max:3",
          maxlength: "3"
        }),
        _hoisted_15
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(ResumeSelect, {
            name: `allowanceId1`,
            label: "選択",
            id: "allowance",
            class: "p-recommend-form__select sp-w-100 js-select",
            className: "p-recommend-form__modal-input-select"
          }),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(ValidatableField, {
              class: "p-recommend-form__modal-input-2",
              id: "form-salary-4",
              type: "text",
              name: "allowanceNum1",
              placeholder: "0",
              label: "諸手当1（金額）",
              rules: "numeric|max:2",
              maxlength: "2"
            }),
            _hoisted_22
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createVNode(ResumeSelect, {
            name: `allowanceId2`,
            label: "諸手当2",
            id: "allowance",
            class: "p-recommend-form__select sp-w-100 js-select",
            className: "p-recommend-form__modal-input-select"
          }),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(ValidatableField, {
              class: "p-recommend-form__modal-input-2",
              id: "form-salary-5",
              type: "text",
              name: "allowanceNum2",
              placeholder: "0",
              label: "諸手当2（金額）",
              rules: "numeric|max:2",
              maxlength: "2"
            }),
            _hoisted_27
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createVNode(ResumeSelect, {
            name: `allowanceId3`,
            label: "選択",
            id: "allowance",
            class: "p-recommend-form__select sp-w-100 js-select",
            className: "p-recommend-form__modal-input-select"
          }),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(ValidatableField, {
              class: "p-recommend-form__modal-input-2",
              id: "form-salary-6",
              type: "text",
              name: "allowanceNum3",
              placeholder: "0",
              label: "諸手当3（金額）",
              rules: "numeric|max:2",
              maxlength: "2"
            }),
            _hoisted_32
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createVNode(ResumeSelect, {
            name: `allowanceId4`,
            label: "選択",
            id: "allowance",
            class: "p-recommend-form__select sp-w-100 js-select",
            className: "p-recommend-form__modal-input-select"
          }),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(ValidatableField, {
              class: "p-recommend-form__modal-input-2",
              id: "form-salary-7",
              type: "text",
              name: "allowanceNum4",
              placeholder: "0",
              label: "諸手当4（金額）",
              rules: "numeric|max:2",
              maxlength: "2"
            }),
            _hoisted_37
          ])
        ])
      ])
    ])
  ]))
}
}

})